export enum HorizontalPositionOfCreelPositionType {
  COLOR,
  GROUP,
  YARN_TYPE
}
